import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/solanova/Logo";

const links = [
  { id: "ueber-uns", label: "Über uns" },
  { id: "leistungen", label: "Leistungen" },
  { id: "foerder-check", label: "Förderung" },
  { id: "solar-check", label: "Solar-Check" },
  { id: "faq", label: "FAQ" },
  { id: "kontakt", label: "Kontakt" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-nav py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => go("hero")}
          className="flex items-center"
          aria-label="Solanova Home"
        >
          <Logo size="sm" />
        </button>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-[13px] tracking-wide text-white/70 hover:text-white transition-colors font-body"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-cta-desktop"
          onClick={() => go("solar-check")}
          className="hidden md:inline-flex btn-bronze rounded-full px-5 py-2 text-sm font-medium"
        >
          Solar-Check starten
        </button>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white/80"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menü"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden glass-nav border-t border-white/5 mt-3">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left text-white/80 hover:text-white text-base font-body"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-cta-mobile"
              onClick={() => go("solar-check")}
              className="btn-bronze rounded-full px-5 py-3 text-sm font-medium mt-2"
            >
              Solar-Check starten
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
